// у автора BookListItem
// информация для карточек с news
<template >

  <v-lazy
    v-model="isActive"
    :options="{threshold: .5}"
    min-height="220"
    transition="fade-transition"
  >
 <!-- :to="{ name: 'pets', params: { id: dog.id } }" -->
 
    <v-card
     
      id="animalCard"
      height="100%"
      width="auto"
      elevation="3"
      
    >
      <v-row no-gutters  class="justify-center pt-4">
        <v-card-title v-text="news.newsTitle" class="textColor text-decoration-underline text-uppercase headline font-weight-medium textWordBreak"></v-card-title>
      </v-row>



      <v-row class="ma-1 ">
        <v-col
          v-for="(img, k) in news.images"
          :key="k"
          class="d-flex child-flex col-sm-10 offset-sm-1 col-md-6 offset-md-0 col-lg-4 col-xl-4 "
          
        >
          <v-img
            :src="img"
            class="white"
            max-height='400'
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-col>
      </v-row>
      
      <v-card-subtitle class="textWordBreak py-0">
        <v-card-text align="justify" class="py-0">
        {{news.userDate}}
          <!-- {{ news.timestamp.toDate().getDate()  }} / {{ news.timestamp.toDate().getMonth()  }} / {{ news.timestamp.toDate().getFullYear()  }} -->
        </v-card-text>
      </v-card-subtitle>

      <v-card-subtitle class="textWordBreak pt-0">
        <v-card-text align="justify" v-html="news.emojiText">
          <!-- {{ news.emojiText }} -->
        </v-card-text>
      </v-card-subtitle>
       

<v-row no-gutters  class="justify-left ">

      <v-btn
        v-if="isUserAuthentificated"
        class="ml-3 mb-3"
        fab
        dark
        small
        color="green"
        :to="{ name: 'newsettings', params: { id: news.id } }"
      >
        <v-icon dark>mdi mdi-pencil</v-icon>
      </v-btn>

<!-- :to="{ name: 'deletepet', params: { id: dog.id } }" -->
      <v-btn
        v-if="isUserAuthentificated"
        @click="deleteNewsDialog(news.id)"
        class="ml-3 mb-3"
        fab
        dark
        small
        color="red"
      >
        <v-icon dark>mdi mdi-trash-can-outline</v-icon>
      </v-btn>
</v-row>

       <v-row justify="center">
        <v-dialog
          v-model="dialog"
          persistent
          max-width="290"
        >
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
            >
            </span>
          </template>
          <v-card >
            <v-card-title  class="red white--text headline justify-center">
              ВНИМАНИЕ !!!
            </v-card-title>
            <v-card-text class="title  my-3 py-0">Вы действительно хотите удалить новость?</v-card-text>
            <v-card-actions  class="grey lighten-3 mt-1" >
              
              <v-btn
                color="green darken-1"
                text
                @click="deleteNewsFromDB('No')"
              >
                Отменить
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                text
                @click="deleteNewsFromDB('Yes')"
              >
                Удалить
              </v-btn>


            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

    </v-card>
    
  </v-lazy>
  
</template>

<script>
import Vue from "vue";
export default {
  data: () => ({
      isActive: false,
      dialog: false,
      deletedID: null,
    
      // curentIMG: null,
      // overlay: false
    }),
  props: {
    news: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isUserAuthentificated() {
      return this.$store.getters.isUserAuthentificated;
    },
  },

  methods: {

    currentDate(date) {
      let curDay = date.toDate().getDate();
      let curMonth = date.toDate().getMonth();
      let curYear = date.toDate().getFullYear();
      let curDate = curDay + ' / ' + curMonth + ' / ' + curYear;
      console.log(curDate);
      return  curDate;
    },
      
    // deleting dialog
    deleteNewsDialog(newsID) {
      this.deletedID = newsID;
      this.dialog = true;
    },

     // удаление данных из БД
    deleteNewsFromDB(descision) {
      if (descision == 'Yes') {
        // удаление старой фото из базы
         this.deleteNewsPhoto();
      }
      this.dialog = false;
    },

    // удаление старой фото из базы
    deleteNewsPhoto() {
      let db2 = Vue.$db.collection("news").doc(this.deletedID);
      db2.get().then((doc) => {
        let img = doc.data().images
      
          Object.keys(img).forEach(key => {
            // console.log(key);
            let ref = Vue.$storageRef.child("newsIMG/" + key);
            // Delete photos
            ref.delete()
              .then(() => {
                console.log("Photos deleted successfully");
              })
              .catch((error) => {
                console.log(error);
              })
             
          });

           // Delete existing document in collection "News" by ID
          let db =  Vue.$db.collection("news").doc(this.deletedID);
            db.delete().then(() => {
              console.log("Document successfully deleted!");
              // переход на страницку с питомцами
              
            }).catch((error) => {
              console.error("Error removing document: ", error);
            });

      }).then(() =>{
        this.deletedID = null;
        this.dialog = false;
      }).catch((error) => {
          console.log("Error getting document:", error);
      });
      
      
      

    },

     

    // // return to the previous scroll location
    // goBack() {
    //   window.history.back()
    // }

    // // shows selected image in the big frame
    // showIMG(src){
    //   // this.curentIMG = src;
    //   let imgOverlay = {
    //     level: true,
    //     img: src,
    //   };
    //   this.$store.dispatch('SHOW_OVERLAY', imgOverlay)
    // }
  }
};
</script>

<style scoped>
#animalCard {
  /* min-height: 350px; */
  color: royalblue;
}

/* кнопка на карточке на весь контейнер */
.v-card__actions {
  padding: 0px;
}

/* отступ слева от фото */
.v-application .ml-1 {
  margin-left: -1px !important;
}

/* отображение текста в карточке не шире 3-х строк + ... */
#subtitleText {
  height: calc(
    24px * 2
  ); /* не стал писать 75px, чтобы показать, что максимум по высоте на 3 строки выделяю блок */
  padding-top: 10px;
  margin-bottom: 10px;
  overflow: hidden;
  line-height: 20px; /* каждая строка будет по высоте 25px, чтобы я точно мог установить высоту блока (это чисто визуально, ни на что не влияет) */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.textColor {
  color: #546E7A;
}
</style>
